// Domains
import RichText from '@src/quince-site-common/src/domains/RichText'

// Hooks
import useDynamicStyle from '@src/quince-site-common/src/hooks/useDynamicStyle'

// Helpers
import getCookie from '@src/quince-site-common/src/utils/getCookie'
import setCookie from '@src/quince-site-common/src/utils/setCookie'
import classNames from 'classnames'
import { useEffect, useState } from 'react'

// Components
import { RichText as RichTextClass, RichTextProps } from '../../molecules'

// Styles
import styles from './product-comparison-section-new.module.scss'
import { ComparisionColumn } from './product-comparison-section-new.types'
import ProductComparisonTableNew from './product-comparison-table-new'

export const DEFAULT_NUMBER_OF_COLUMNS = 4

// @i18n-ignore
const PDP_COMPARISON_COLUMN_COUNT_COOKIE_NAME = 'pdpComparisionColumnCount'

export interface ProductComparisonSectionNewProps {
  newProductComparisonSectionContent?: ComparisionColumn[]
  title?: RichText
  subtitle?: RichText
  rowHeaders?: RichText[]
  className?: string | undefined
  headerClassName?: string | undefined
  tableClassName?: string | undefined
  mobileClassNamesOverride?: string[]
  baseClassNames?: string[]
  baseDynamicValueClasses?: string[]
  dynamicValueClassesMobileOverride?: string[]
  numberOfColumns?: number
}

const ProductComparisonSectionNew = ({
  className,
  headerClassName,
  tableClassName,
  newProductComparisonSectionContent,
  title,
  subtitle,
  mobileClassNamesOverride,
  baseClassNames,
  baseDynamicValueClasses,
  dynamicValueClassesMobileOverride,
  numberOfColumns = DEFAULT_NUMBER_OF_COLUMNS,
}: ProductComparisonSectionNewProps) => {
  const { className: wrapperClassname, styleObject } = useDynamicStyle({
    mobileClassNamesOverride,
    baseClassNames,
    baseDynamicValueClasses,
    dynamicValueClassesMobileOverride,
    postFix: styles.dynamicClassesPostFix,
  })

  const [numColumns, setNumColumns] = useState(numberOfColumns)

  const classes = classNames(styles.comparisonWrapper, className, wrapperClassname)
  const titleRichTextProps: RichTextProps | undefined = RichText.makeRichTextProps(title)
  const subtitleRichTextProps: RichTextProps | undefined = RichText.makeRichTextProps(subtitle)

  useEffect(() => {
    const queryParamColumnCountFromCookie = getCookie(PDP_COMPARISON_COLUMN_COUNT_COOKIE_NAME)
    const currentUrl = new URL(window.location.href)
    const valFromQueryParam = currentUrl.searchParams.has(PDP_COMPARISON_COLUMN_COUNT_COOKIE_NAME)
      ? Number(currentUrl.searchParams.get(PDP_COMPARISON_COLUMN_COUNT_COOKIE_NAME))
      : undefined
    if (valFromQueryParam) {
      setNumColumns(valFromQueryParam)
      setCookie(PDP_COMPARISON_COLUMN_COUNT_COOKIE_NAME, String(valFromQueryParam))
    } else if (queryParamColumnCountFromCookie) {
      setNumColumns(Number(queryParamColumnCountFromCookie))
    }
  }, [])

  return (
    <div className={classes} style={styleObject}>
      <div className={`${styles.wrapper__text} ${headerClassName || ''}`}>
        {title && titleRichTextProps && (
          <RichTextClass {...titleRichTextProps} className={styles.wrapper__text__title} />
        )}
        {subtitle && subtitleRichTextProps && (
          <RichTextClass {...subtitleRichTextProps} className={styles.wrapper__text__subtitle} />
        )}
      </div>
      <ProductComparisonTableNew
        columns={newProductComparisonSectionContent || []}
        className={tableClassName}
        numberOfColumns={numColumns || numberOfColumns}
      />
    </div>
  )
}

export default ProductComparisonSectionNew
